export default __webpack_public_path__ + "static/media/EimantasJanusis.899d45be.webp";